import { gql } from '@apollo/client'
import { useCleanFilterForRequest, useSearch, useSort } from '@btime/react-contexts'
import React from 'react'

import { compliancesClient } from '../../../../utils/apollo/api'
import { getQueryParam } from '../../../../utils/helpers/url'
import { usePaginatedQuery } from '../../../../utils/apollo/_helpers/pagination'
import LazyAction from '../../../../components/helpers/LazyAction'
import StatePresenter from '../../../../components/helpers/StatePresenter'
import { convertFilterToRelativeDates } from '../../../../utils/helpers/date'

const Context = React.createContext([])
const { Provider } = Context
export const usePlaceNonCompliancesState = () => React.useContext(Context)
export const usePlaceNonCompliances = () => usePlaceNonCompliancesState()?.placeNonCompliances

const QUERY = gql`
  query PlaceNonCompliances(
    $page: Int
    $search: String
    $sort: [PlaceNonComplianceSort]
    $filter: PlaceNonComplianceFilter
  ) {
    placeNonCompliances(page: $page, search: $search, sort: $sort, filter: $filter) {
      place {
        id
        name
        resume
      }
      nonCompliancesCount
      openNonCompliancesCount
      doneNonCompliancesCount
      startDate
      endDate
    }
  }
`

const PlaceNonCompliancesLoader = ({ children, uncontrolledChildren }) => {
  const { field, type } = useSort()
  const search = useSearch()
  let filter = useCleanFilterForRequest()
  filter = convertFilterToRelativeDates(filter)
  const origin = getQueryParam('origin') || 'serviceOrder'

  const { data, fetchMore, ...state } = usePaginatedQuery(QUERY, {
    variables: {
      page: 1,
      search,
      sort: [{ field: field || 'OPEN_NON_COMPLIANCES_COUNT', type: type || 'DESC' }],
      filter: { origins: origin, ...filter }
    },
    client: compliancesClient
  })

  return (
    <Provider value={data}>
      <StatePresenter {...state} uncontrolledChildren={uncontrolledChildren}>
        {children}
        <LazyAction action={fetchMore} waiting={state.loading || state.isFetchingMore} />
      </StatePresenter>
    </Provider>
  )
}

export default PlaceNonCompliancesLoader
